import { useContext } from 'react'
import { DispatchContext } from './context'

const useEMTDispatch = () => {
  const dispatch = useContext(DispatchContext)

  return dispatch
}

export default useEMTDispatch
